import React from "react";
import { InputNumber } from "primereact/inputnumber";
import localeText from "../../../../../../../locale";

function VariationCombinationsTable({
  combinations,
  onChange,
  onSelectImage,
  currencyCode = "EUR",
  stockDisabled = false,
}) {
  const update = (index, patch) => {
    onChange(combinations.map((item, i) => (i === index ? { ...item, ...patch } : item)));
  };

  if (!combinations?.length) return null;

  return (
    <div className="product-form-variations-table flex flex-column gap-2">
      <div className="product-form-variations-table-head text-sm">
        <span>{localeText("variant")}</span>
        <span>{localeText("variantPrice")}</span>
        <span>{localeText("variantStock")}</span>
        <span />
      </div>
      {combinations.map((combo, index) => (
        <React.Fragment key={combo.key}>
          {index > 0 && (
            <hr className="m-0 p-0" />
          )}
          <div className="product-form-variations-table-row gap-2">
            <span className="text-sm font-medium">{combo.label}</span>
            <InputNumber
              value={combo.price}
              onValueChange={(e) => update(index, { price: e.value })}
              mode="currency"
              currency={currencyCode}
              locale="de-DE"
              className="input-variation border-round-lg"
              placeholder="0,00"
            />
            <InputNumber
              value={combo.stock}
              onValueChange={(e) => update(index, { stock: e.value ?? 0 })}
              className="input-variation border-round-lg"
              min={0}
              placeholder="0"
              disabled={stockDisabled}
            />
            {/* <button
            type="button"
            className="product-form-variation-image"
            onClick={() => onSelectImage(index)}
            aria-label={localeText("selectImage")}
          >
            {combo.previewUrl || combo.imageId ? (
              <img src={combo.previewUrl} alt="" />
            ) : (
              <i className="pi pi-image" />
            )}
          </button> */}
          </div>
        </React.Fragment>
      ))}
    </div>
  );
}

export default VariationCombinationsTable;
